<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.bottomFavorites]:
          favorites.length > ($screen === 's' ? 3 : $screen === 'm' ? 4 : 6)
      }
    ]"
  >
    <Favorites :class="$style.favorites" />
    <div>
      <BrowserItem
        v-for="(item, index) in items"
        :key="index"
        :item="item"
        arrow
        :borderTop="index === 0"
        @click="$router.push({ name: item.routeName })"
        v-test="`register-browser-${item.name}`"
      >
        <BaseIcon
          :name="item.icon"
          :class="$style.icon"
        />
        {{ item.label }}
      </BrowserItem>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { IconName } from '@/components/base-icon/types';
import filters from '@/filters';
import { useUserStore } from '@/stores/user';
import BrowserItem from '../../BrowserItem.vue';
import { useRegisterBrowserStore } from '../../store';
import Favorites from './favorites/index.vue';

const { t } = useI18n();
const { hasFeatureFlag } = useUserStore();

const { favorites } = storeToRefs(useRegisterBrowserStore());

type BrowserItemType = {
  name: string;
  routeName: string;
  icon: IconName;
  label: string;
};

const items = computed<BrowserItemType[]>(() =>
  [
    {
      name: 'services',
      routeName: 'register-builder-services',
      icon: 'scissors',
      label: filters.capitalize(t('global.items.service', 2)),
    },
    {
      name: 'products',
      routeName: 'register-builder-products',
      icon: 'pricetag',
      label: filters.capitalize(t('global.items.product', 2)),
    },
    {
      name: 'appointments',
      routeName: 'register-builder-appointments',
      icon: 'calendar',
      label: filters.capitalize(t('global.items.appointment', 2)),
      hide: !hasFeatureFlag('module-appointments'),
    },
    {
      name: 'giftcard',
      routeName: 'register-builder-giftcard',
      icon: 'gift',
      label: filters.capitalize(t('global.items.giftcard', 1)),
    },
    {
      name: 'prepaidcard',
      routeName: 'register-builder-prepaidcard',
      icon: 'credit-card',
      label: filters.capitalize(t('global.items.prepaid_card', 1)),
      hide: hasFeatureFlag('fiskaly-sign-enabled'),
    },
  ].filter((item) => !item.hide),
);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;

  &.bottomFavorites {
    flex-direction: column-reverse;
  }
}

.icon {
  margin-right: $spacing * 0.5;
}

.favorites {
  .base:not(.bottomFavorites) & {
    margin-bottom: $spacing;
  }

  .base.bottomFavorites & {
    margin-top: $spacing;
  }
}
</style>
